<div *ngIf="confirmationService.isOpen()" appPreventScroll
  class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
  <div
    class="bg-white rounded-xl w-full max-w-[400px] overflow-hidden transform transition-all flex flex-col items-center text-center">
    <!-- Header / Icon -->
    <div class="px-4 py-6 sm:p-6 lg:p-8 flex flex-col gap-4 items-center">
      <div class="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-8 h-8">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
      </div>

      <h3 class="text-lg sm:text-xl lg:text-2xl font-semibold text-black leading-snug">
        {{ confirmationService.title() }}
      </h3>
      <p class="text-sm lg:text-base font-normal text-black/70 leading-5">
        {{ confirmationService.message() }}
      </p>
    </div>

    <!-- Footer / Actions -->
    <div class="px-4 py-5 sm:p-5 lg:px-8 lg:pb-8 flex gap-4 w-full justify-center">
      <button type="button" (click)="onCancel()"
        class="rounded-lg border border-[var(--color-gray-1)] text-sm xl:text-base font-medium text-black bg-[var(--color-gray-3)] hover:bg-[var(--color-gray-7)] transition duration-300 ease-in-out p-2.5 sm:py-3 sm:px-6 cursor-pointer flex-1">
        {{ confirmationService.cancelButtonText() }}
      </button>
      <button type="button" (click)="onConfirm()"
        class="rounded-lg bg-orange-600 text-sm xl:text-base font-semibold text-white hover:bg-orange-700 transition duration-300 ease-in-out p-2.5 sm:py-3 sm:px-6 cursor-pointer flex-1 flex justify-center items-center gap-2 border border-transparent">
        {{ confirmationService.confirmButtonText() }}
      </button>
    </div>
  </div>
</div>